import authentication from "@/store/modules/authentication";
import azure from "@/store/modules/azure";
import arctitan from "@/store/modules/arctitan";
import history from "@/store/modules/history";
import locations from "@/store/modules/locations";
import microsoftConnect from "@/store/modules/microsoftConnect";
import pageMeta from "@/store/modules/pageMeta";
import users from "@/store/modules/users";
import passwordReset from "./passwordReset";
import organisations from "@/store/modules/organisations";
import messagesAnalysed from "./messagesAnalysed";
import arcTitan from "@/modules/ArcTitan/store/arcTitan";
import solutions from "./solutions";
import dropDown from "./dropDown";
import branding from "./branding";

export default {
  authentication,
  azure,
  arctitan,
  history,
  locations,
  microsoftConnect,
  pageMeta,
  users,
  organisations,
  passwordReset,
  messagesAnalysed,
  arcTitan,
  solutions,
  dropDown,
  branding,
};
